import { createAction } from 'redux-actions';
import {   
    SET_FORMVALUE
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import {apiPrefixUrl} from '../utils/connection'
import Swal from 'sweetalert2'
import {setResultValue} from './resultAction'
import {getReserveDate, getReserveTime} from './optionAction'
import { history } from '../router/history'
import { formDefault } from '../constants/model'
import { setOption } from './optionAction'

export const setFormValue = createAction(SET_FORMVALUE)

export const resetForm = ()=>{
    return (dispatch, getState) => {
        _.map(formDefault, (item, key)=>{
            dispatch(setFormValue({
                field:key,
                value:item
            }))
        })

        dispatch(setOption({field:"reserveType",options:[]}))
        dispatch(setOption({field:"reserveDate",options:[]}))
        dispatch(setOption({field:"reserveTime",options:[]}))
        dispatch(setOption({field:"AREA_CODE",options:[]}))
    }
}

export const submit = () =>{
    return (dispatch, getState) => {

        const form = (getState().getIn(["form"])).toJS()
        const timeOptions = (getState().getIn(["option", "reserveTime"])).toJS()

        if(!form.PAT_NAME){
            Swal.fire("請輸入姓名", "", "error")
            return 
        }

        if(!form.PAT_IDNO){
            Swal.fire("請輸入身分證字號", "", "error")
            return 
        }

        if(!form.TEL_MOBILE){
            Swal.fire("請輸入手機號碼", "", "error")
            return 
        }

        // if(!form.EMAIL){
        //     Swal.fire("請輸入e-mail", "", "error")
        //     return 
        // }
        
        // const ConformIdneedOCC = ["C01","C02","C03","C05","C07"]

        // if(ConformIdneedOCC.indexOf(form.conformId)>-1){
        //     if(!form.OCC_COMP){
        //         Swal.fire("請輸入工作機構/公司", "", "error")
        //         return
        //     }

        //     if(!form.OCC_TITLE){
        //         Swal.fire("請輸入職稱", "", "error")
        //         return
        //     }
        // }

        if(!form.SEX){
            Swal.fire("請輸入性別", "", "error")
            return 
        }

        if(!form.BIRTHDAY){
            Swal.fire("請輸入生日", "", "error")
            return 
        }

        // if(!form.AREA_CODE){
        //     Swal.fire("請選擇通訊地址鄉鎮市區", "", "error")
        //     return 
        // }

        // if(!form.ADDRESS){
        //     Swal.fire("請填寫通訊地址", "", "error")
        //     return 
        // }

        if(!form.DOSAGE_COUNT){
            Swal.fire("請填寫施打第幾劑", "", "error")
            return 
        }

        // if(parseInt(form.DOSAGE_COUNT) > 1 && !form.PRE_VACCINE_TYPE){
        //     Swal.fire("請填寫前次施打品牌", "", "error")
        //     return 
        // }

        const timeSlot = _.find(timeOptions, (o)=>{return o.value === form.reserveTimeId})

        if(!timeSlot){
            Swal.fire("token錯誤", "", "error")
            return 
        }

        dispatch(setFormValue({field:"loading", value:true}))

        const payload = {
            "api":"Booking",
            "SCHD_ID":form.reserveTimeId,
            "PAT_IDNO":form.PAT_IDNO,
            "PAT_NAME":form.PAT_NAME,
            "BIRTHDAY":form.BIRTHDAY,
            "SEX":form.SEX,
            "TEL_MOBILE":form.TEL_MOBILE,
            "EMAIL":form.EMAIL,
            "OCC_COMP":form.OCC_COMP,
            "OCC_TITLE":form.OCC_TITLE,
            "CONFORM_TYPE":form.conformId,
            "AREA_CODE":form.AREA_CODE,	
            "ADDRESS":form.ADDRESS,	
            "DOSAGE_COUNT":form.DOSAGE_COUNT, //施打第幾劑疫療
            "PRE_VACCINE_TYPE":form.PRE_VACCINE_TYPE, //如果施打第二劑，在詢問前一劑施打品牌 ,
            "TOKEN":timeSlot.token,
            "USER_ID":"patient",
            "PRE_VACCINE_DATE":form.PRE_VACCINE_DATE,
            "SPNO":""
        }

        doPost(apiPrefixUrl, payload)
        .then((data)=>{
            if(data.status && data.data){
                dispatch(setResultValue({value:data.data}))
                dispatch(resetForm())
                dispatch(setFormValue({field:"loading", value:false}))
                history.push('/result')
            }else{
                throw Error(data.message)
            }
        })
        .catch((e)=>{
            Swal.fire(e.message, "", "error")
            dispatch(setFormValue({field:"loading", value:false}))
        })
    }
}

export const loadPreviousVaccineData = () =>{
    return (dispatch, getState) => {
        const form = (getState().getIn(["form"])).toJS()
        const option = (getState().getIn(["option"])).toJS()
        if((form.BIRTHDAY && form.BIRTHDAY.length===8) && form.conformId && (form.PAT_IDNO && form.PAT_IDNO.length>9)){
            let payload = {
                "api":"VaccineChecker",              
                "PAT_IDNO":form.PAT_IDNO,
                "BIRTHDAY":form.BIRTHDAY,
                "CONFORM_TYPE":form.conformId,
                "SPNO":"",
                "USER_ID":"patient"
            }
            doPost(apiPrefixUrl, payload)
            .then((data)=>{
                if(data.status && data.data.pass === "Y"){
                    if(data.data.PRE_VACCINE_DATE){
                        dispatch(setFormValue({field:"PRE_VACCINE_DATE", value:data.data.PRE_VACCINE_DATE}))
                    }

                    let DOSAGE_COUNT_STR = ""+data.data.DOSAGE_COUNT
                    if(data.data.DOSAGE_COUNT){
                        dispatch(setFormValue({field:"DOSAGE_COUNT", value:DOSAGE_COUNT_STR}))
                    }
                    const isInVaccineList = _.find(option.reserveType, (o)=>{return o.value === data.data.PRE_VACCINE_TYPE})
                    if(isInVaccineList && data.data.PRE_VACCINE_TYPE){
                        dispatch(setFormValue({field:"reserveType", value:""+data.data.PRE_VACCINE_TYPE}))
                    }

                    //同resetReserveDate
                    dispatch(setFormValue({
                        field: 'reserveDate',
                        value: ''
                    }))
                    dispatch(getReserveDate())
                    
                    //同resetReserveTime
                    dispatch(setFormValue({
                        field: 'reserveTimeId',
                        value: ''
                    }))
                    dispatch(getReserveTime())

                    if(DOSAGE_COUNT_STR === "1"){
            
                        dispatch(setFormValue({
                            field:'PRE_VACCINE_TYPE',
                            value:""
                        }))
                        dispatch(setFormValue({
                            field:'PRE_VACCINE_DATE',
                            value:null
                        }))
                    }
                }else if(data.status && data.data.pass==="N"){
                    throw Error(data.data.msg)
    
                }  else{
                    throw Error(data.message)
                }

               
            }).catch((e)=>{
                Swal.fire(e.message, "", "warning")
            })

        }
    }
}
